module.exports = __webpack_public_path__ + "static/img/index23.031fb2c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index23.gif
// module id = XGuj
// module chunks = 0